import React from 'react';
import { useNavigate } from 'react-router-dom';

import { formatDateTime } from '../../../utils';
import { UserInitials } from '../../UserInitials/UserInitials';
import { ComponentsCount } from '../ComponentsCount/ComponentsCount';

import type { PageListItem, UserResponse } from '../../../types';
import type { FC } from 'react';

import styles from './TemplateRow.module.scss';

type Props = {
  page: PageListItem;
  user?: UserResponse;
};

export const TemplateRow: FC<Props> = ({ page, user }) => {
  const navigate = useNavigate();

  const { id, components } = page;

  return (
    <tr onClick={() => navigate(`/pages/${id}`)} className={styles.row}>
      <td>
        <span className={styles.pageType}>{page.forType} page template</span>
      </td>
      <td>
        <ComponentsCount count={components.length} />
      </td>
      <td />
      <td>
        <div className={styles.updated}>
          {page.updatedAt != null && formatDateTime(page.updatedAt)}
          {user && <UserInitials user={user} className={styles.initials} />}
        </div>
      </td>
    </tr>
  );
};
